import React from "react";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import monoGenoma from "../assets/mono-genoma.png";
import "./process-detail/styles.scss";

const Expired = () => {
  const { t } = useTranslation();

  return (
    <div className="unknown-interview">
      <Card
        className="card"
        title={
          <div style={{ textAlign: "center" }}>
            <img src={monoGenoma} alt="genomin" />
            <h1>{t("frontvint__expired_title")}</h1>
          </div>
        }
      >
        <span>{t("frontvint__expired_content")}</span>
      </Card>
    </div>
  );
};

export default Expired;
